import { doCall } from "common/genericSaga";
import { getGlobalObject } from "helpers/globalObject";
import { all, apply, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { handleError } from "services/errorService";
import { oidc } from "services/oidcService";
import { AUTH_REQUESTED, AUTH_REQUEST_FAILED, AUTH_SIGN_OUT, receiveAuth } from "./authActions";

export function* authenticate() {
  const oidcManager = yield call(oidc.getOidcManager);
  const token = yield apply(oidcManager, oidcManager.getAccessToken);

  if (token) {
    yield put(receiveAuth());
    return;
  }

  let userInfo = null;
  try {
    userInfo = yield apply(oidcManager, oidcManager.signin);
  } catch (e) {
    handleError(e);
    // if is in auth callback
    if (window.location.search.includes("state=")) {
      window.history.pushState(null, null, "/");
      window.location.reload();
    }
  }

  // The first we visit the site oidcManager.signin returns an empty object {}.
  // The second time (after callback) oidcManager.signin returns userInfo with tokens.
  if (userInfo && userInfo.tokens) {
    const globalObject = yield call(getGlobalObject);
    globalObject.trackingHelper.trackAccountSubject(userInfo.sub);
    yield put(receiveAuth());
  }
}

export function* signOut() {
  const oidcManager = yield call(oidc.getOidcManager);
  yield apply(oidcManager, oidcManager.signout);
}

export function* watchAuth() {
  yield all([
    takeLatest(AUTH_REQUESTED, doCall(authenticate, AUTH_REQUEST_FAILED)),
    takeEvery(AUTH_SIGN_OUT, doCall(signOut, AUTH_REQUEST_FAILED))
  ]);
}
